export default "__VITE_ASSET__CZazMg1Z__"